import PraisoServices from "./PraisoServices";
import { getAPIResponse, getToken, setAPIResponse } from "./LocalStorageService";

export const EventSummaryAPI = async (eventsSummaryParams, params) => {
  const ApiUrl = `insights/event-details/${eventsSummaryParams.eventTypeId}`;
  let url = ApiUrl;
  if (eventsSummaryParams.userId) {
    url = `?${eventsSummaryParams.userId}`;
  }
  if (params.impersonationid) {
    url = `${url}&${params.impersonationid}`;
    eventsSummaryParams.impersonationId = params.impersonationid;
  }

  const token = getToken()
  try {
    const data = getAPIResponse(url);
    if (data !== null) {
      return data;
    }
    const response = await PraisoServices(
      ApiUrl,
      "get",
      {},
      {
        ...eventsSummaryParams
      },
      {
        Authorization: `Bearer ${token}`
      }
    );
    try {
      setAPIResponse(url, response);
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const GetSpeedEventsSummaryAPI = async (eventsSummaryParams, params) => {
  const ApiUrl = `insights/speed-event`;
  let url = `${ApiUrl}?${eventsSummaryParams.eventTypeId}`;
  if (eventsSummaryParams.userId) {
    url = `${url}&${eventsSummaryParams.userId}`;
  }
  if (params.impersonationid) {
    url = `${url}&${params.impersonationid}`;
    eventsSummaryParams.impersonationId = params.impersonationid;
  }
  const token = getToken()
  try {
    const data = getAPIResponse(url);
    if (data !== null) {
      return data;
    }
    const response = await PraisoServices(
      ApiUrl,
      "get",
      {},
      {
        ...eventsSummaryParams
      },
      {
        Authorization: `Bearer ${token}`
      }
    );
    try {
      setAPIResponse(url, response);
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const GetMaxSpeedAPI = async (eventsSummaryParams, params) => {
  const ApiUrl = `insights/max-speed`;

  let url = ApiUrl;
  if (params.impersonationid) {
    url = `${url}?${params.impersonationid}`;
    eventsSummaryParams.impersonationId = params.impersonationid;
  }
  const token = getToken()
  try {
    const data = getAPIResponse(url);
    if (data !== null) {
      return data;
    }
    const response = await PraisoServices(
      ApiUrl,
      "get",
      {},
      {
        ...eventsSummaryParams
      },
      {
        Authorization: `Bearer ${token}`
      }
    );
    try {
      setAPIResponse(url, response);
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const getEventsSummary = async (eventsSummaryParams, params) => {
  const data = await EventSummaryAPI(eventsSummaryParams, params);
  return data;
  // if (data.status.code !== 0 && data.status.code !== 200 && data.status.code !== 201) {
  //   return data;
  // } else {
  //   return data;
  // }
};

export const getSpeedEventsSummary = async (eventsSummaryParams, params) => {
  const data = await GetSpeedEventsSummaryAPI(eventsSummaryParams, params);
  return data;
  // if (data && data.status && data.status.code !== 0 && data.status.code !== 200 && data.status.code !== 201) {
  //   return data;
  // } else {
  //   return data;
  // }
};

export const getMaxSpeed = async (eventsSummaryParams, params) => {
  const data = await GetMaxSpeedAPI(eventsSummaryParams, params);
  return data;
  // if (data.status.code !== 0 && data.status.code !== 200 && data.status.code !== 201) {
  //   return data;
  // } else {
  //   return data;
  // }
};
